import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteTicketType } from '../../api/TICKET/ticketMeta';
import { toast } from 'react-toastify';

export const useDeleteTicketType = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteTicketType,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['ticket-types'] });
            toast.success('Type de ticket supprimé avec succès');
        },
        onError: (error) => {
            toast.error(error.message || 'Erreur lors de la suppression du type de ticket');
        },
    });
};

